import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArmStrong = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M14.5 15C14.474 16.2469 14.56 17.4935 14.757 18.725C15.128 20.367 16.745 22.08 17.038 22.834C18.625 20.954 24.161 18.834 27.563 20.615C31.463 23.132 31.134 27.365 28.59 29.208C26.6015 30.374 24.3382 30.9891 22.033 30.99C20.2275 31.1458 18.4091 30.9352 16.687 30.371C15.325 30.545 12.447 30.525 11.272 29.328C10.466 28.507 8.817 23.8 9.808 18.773C10.854 13.466 12.6 9.00002 14.492 9.00002C15.5714 8.90081 16.6568 9.10881 17.623 9.60002C18.323 10.169 17.823 11.867 17.6 12.1C17.8371 12.2892 17.9938 12.5611 18.0385 12.8611C18.0832 13.1611 18.0126 13.4669 17.841 13.717C17.2701 14.365 16.5281 14.8388 15.7 15.084C15.2986 15.1412 14.8896 15.1126 14.5 15V15Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M19.5 26C21.8737 26.6059 24.3908 26.2463 26.5 25",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	})]
});
const ForwardRef = forwardRef(SvgArmStrong);
export default ForwardRef;
